module.exports = __webpack_public_path__ + "img/usuario.81dd3648.svg";